import {useAgyleConfigStyles} from '../../agyle_configuration';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import AgyleAccordion from '../../../../components/ui/accordion/agyleAccordion';
import React, {useEffect, useRef, useState} from 'react';
import MessageBox from '../../../../util/messageBox';
import useOpenState from '../../../../hooks/useOpenState';
import WardSelectionCleaningRequest from './wardSelectionCleaningRequest';
import _ from 'lodash';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';
import {multiHospitalMode} from '../../../../store/reducers/ward';

const WardManageConfigurationCleaningRequest = ({cfg, handleSaveConfig}) => {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();

    const isMultiHospitalMode = useSelector(multiHospitalMode);

    // List
    const [list, setList] = useState([]);
    const columnsTable = [
        createAgyleTableColumn('ward', 'Ward', 1, 'name', 'string', '', 'medium', 'left', true, true, 150, null),
        createAgyleTableColumn('wardId', 'Ward Id', 2, 'wardId', 'string', '', 'medium', 'left', true, true, 150, null),
        createAgyleTableColumn('hospitalId', 'Hospital Id', 3, 'hospitalId', 'string', '', 'medium', 'left', true, true, 150, null, null, isMultiHospitalMode),
        createAgyleTableColumn('managed', 'Managed', 4, 'option', 'startCase', '', 'medium', 'left', true, true, 150, null),
        createAgyleTableColumn('action', 'Delete', 5, null, 'action', '', 'medium', 'right', true, true, 150, null),
    ];

    // Accordion
    const [expanded, setExpanded] = useState(true);

    // Delete state
    const [isConfirmOpen, openConfirm, closeConfirm] = useOpenState(false, true);
    const tempId = useRef(null);

    // Load from config
    useEffect(() => {
        if (cfg?.value?.wards) {
            setList(cfg?.value?.wards);
        }
    }, [cfg]);

    const onSave = (listWards) => {
        handleSaveConfig('wards', listWards);
    };

    const handleCloseDelete = () => {
        closeConfirm();
        tempId.current = null;
    };

    const handleDeleteWard = () => {
        if (tempId.current) {
            let clone = _.cloneDeep(list);
            clone = _.filter(clone, w => w.id !== tempId.current);
            setList(clone);
            onSave(clone);
        }
        handleCloseDelete();
    };

    const handleAddNewElement = (item) => {
        const clone = _.cloneDeep(list);
        clone.push(item);
        setList(clone);
        onSave(clone);
    };

    const handleDelete = (item) => {
        if (item?.id) {
            tempId.current = item?.id;
            openConfirm();
        }
    };

    return (
        <>
            <div className={classes.smallContext}>
                <WardSelectionCleaningRequest
                    list={list}
                    onAdd={handleAddNewElement}
                />
            </div>

            <div className={classes.smallContext} style={{marginTop: 10}}>
                <AgyleAccordion
                    expanded={expanded}
                    onChange={() => setExpanded(!expanded)}
                    label={t('List')}
                >
                    <AgyleTable
                        columns={columnsTable}
                        data={list}
                        deleteItem={handleDelete}
                        disableFilter
                        edRefresh
                    />
                </AgyleAccordion>
            </div>

            <MessageBox
                open={isConfirmOpen}
                onClose={handleCloseDelete}
                title={t('Confirmation')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={handleDeleteWard}
                message={t('Are you sure you want to delete this record?')}
            />
        </>
    );
};

export default WardManageConfigurationCleaningRequest;